export default __webpack_public_path__ + "static/media/09-nonprofit_preview.a64cb17c.jpg";